import React, { useRef, useState } from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";

const emailJsServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_17f9mvt";
const emailJsTemplateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_lmnbf8a";
const emailJsPublicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "o7P2Yy_3B-1__j6WS";
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LcQUQktAAAAABrHoOYx1mcWqa6OGVwirrXnKcSF";

export default function ContactForm() {
  const recaptchaRef = useRef();
  const [formStatus, setFormStatus] = useState("");

  const isFormConfigured = Boolean(
    emailJsServiceId && emailJsTemplateId && emailJsPublicKey && recaptchaSiteKey
  );

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!isFormConfigured) {
      setFormStatus("The contact form is not configured yet. Please call or email us directly.");
      return;
    }

    const token = recaptchaRef.current?.getValue();
    if (!token) {
      setFormStatus("Please verify you're not a robot.");
      return;
    }

    const formData = new FormData(event.currentTarget);
    const templateParams = {
      ...Object.fromEntries(formData.entries()),
      to_email: "fiestaevent9@gmail.com",
      "g-recaptcha-response": token,
    };

    emailjs.send(
      emailJsServiceId,
      emailJsTemplateId,
      templateParams,
      { publicKey: emailJsPublicKey }
    ).then(
      () => {
        setFormStatus("Message sent successfully!");
        event.target.reset();
        recaptchaRef.current.reset();
      },
      (error) => {
        const errorText = error?.text || error?.message || "Please try again.";
        setFormStatus(`Failed to send message: ${errorText}`);
      }
    );
  };

  return (
    <section className="bg-white py-12 sm:py-20 px-4 sm:px-6">
      <h2 className="text-3xl sm:text-4xl font-bold text-center mb-2 font-serif elegant-font leading-tight">Get In Touch</h2>
      <p className="text-center text-gray-600 mb-8 sm:mb-10 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
        We make your event look beautiful from the first idea to the final photo.
        Tell us what you are planning, and we will help bring the decor together.
      </p>
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-0 bg-white shadow rounded-lg overflow-hidden">
        <div className="bg-pink-50 p-6 sm:p-8 space-y-5 sm:space-y-6 text-gray-700">
          <div className="flex items-start gap-4">
            <FaMapMarkerAlt className="text-2xl mt-1 text-rose-400 flex-shrink-0" aria-hidden="true" />
            <div>
              <h4 className="text-xl font-semibold elegant-font">Visit Us:</h4>
              <p className="text-sm uppercase mt-1">20 Sutton Dr<br />Cohoes, NY</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <FaEnvelope className="text-2xl mt-1 text-rose-400 flex-shrink-0" aria-hidden="true" />
            <div>
              <h4 className="text-xl font-semibold elegant-font">Mail Us:</h4>
              <p className="text-sm mt-1">fiestaevent9@gmail.com</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <FaPhoneAlt className="text-2xl mt-1 text-rose-400 flex-shrink-0" aria-hidden="true" />
            <div>
              <h4 className="text-xl font-semibold elegant-font">Call Us:</h4>
              <p className="text-sm mt-1">412.228.9722</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 sm:p-8 space-y-4 bg-white">
          <h4 className="text-2xl font-semibold mb-4 elegant-font leading-tight">Tell Us About Your Event</h4>
          {!isFormConfigured && (
            <p className="text-center text-sm font-medium mb-2 text-amber-700">
              Contact form settings are missing. Please use the email or phone number shown here.
            </p>
          )}
          {formStatus && (
            <p className="text-center text-sm font-medium mb-2 text-green-600">
              {formStatus}
            </p>
          )}

          <input name="full_name" type="text" placeholder="Name" className="w-full border border-gray-300 p-3 rounded" required />
          <input name="email" type="email" placeholder="Email" className="w-full border border-gray-300 p-3 rounded" required />
          <input name="phone" type="tel" placeholder="Phone" className="w-full border border-gray-300 p-3 rounded" required />

          <select name="service" className="w-full border border-gray-300 p-3 rounded" required>
            <option value="">Event type</option>
            <option>Wedding</option>
            <option>Birthday</option>
            <option>Womensday</option>
          </select>

          <div className="grid gap-2 sm:grid-cols-2">
            <input name="event_date" type="date" className="w-full border border-gray-300 p-3 rounded" required />
            <input name="event_location" type="text" placeholder="Event location" className="w-full border border-gray-300 p-3 rounded" required />
          </div>

          <textarea name="message" placeholder="Message" className="w-full border border-gray-300 p-3 rounded" rows="4" required />
          <input type="hidden" name="to_email" value="fiestaevent9@gmail.com" />

          {recaptchaSiteKey && (
            <div className="w-full flex justify-center">
              <ReCAPTCHA sitekey={recaptchaSiteKey} ref={recaptchaRef} />
            </div>
          )}

          <button type="submit" className="w-full bg-rose-400 hover:bg-rose-500 text-white py-3 px-4 rounded">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
